'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LD_CLIENT_FAILED = exports.USER_FLAGS_INIT_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.clearFixtures = clearFixtures;
exports.replaceFixtures = replaceFixtures;
exports.getLDUser = getLDUser;

var _launchdarklyJsClientSdk = require('launchdarkly-js-client-sdk');

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _User = require('./User');

var _User2 = _interopRequireDefault(_User);

var _stringUtils = require('../helper/stringUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_FLAGS_INIT_FAIL = exports.USER_FLAGS_INIT_FAIL = 'Client could not be initialized and no fixtures were provided'; // https://docs.launchdarkly.com/docs/js-sdk-reference
var LD_CLIENT_FAILED = exports.LD_CLIENT_FAILED = 'Client encountered an error that prevented it from connecting to LaunchDarkly';

// LaunchDarkly: Client-side ID
// https://docs.launchdarkly.com/docs/js-sdk-reference#section-initializing-the-client
var ldClientSideId = process.env.LD_CLIENT_SIDE_ID || _User2.default.ldClientSideId() || (window ? window.LD_CLIENT_SIDE_ID : undefined);

// LaunchDarkly: User hash for "Secure Mode"
// https://docs.launchdarkly.com/docs/js-sdk-reference#section-secure-mode
var LD_USER_HASH = process.env.LD_USER_HASH || (window ? window.LD_USER_HASH : undefined);

// Initialize LaunchDarkly client library options
var options = {};

if ((0, _isString2.default)(LD_USER_HASH)) options.hash = LD_USER_HASH;

var client = void 0,
    user = void 0;
var clientStatus = {
  failed: false,
  initialized: false

  // Test helpers for managing feature flag fixture data
  // PURPOSE: Provide ability to short-circuit LaunchDarkly client library API requests
};var fixtures = {};

function clearFixtures() {
  fixtures = {};
}
function replaceFixtures(newFixtures) {
  fixtures = newFixtures;
}

/**
 * Create LaunchDarkly user object from Unified User class data
 *
 * @return {Object} LaunchDarkly user object
 */
function createUser() {
  // LaunchDarkly supports a set of standard attributes (see docs) ...
  // https://docs.launchdarkly.com/docs/targeting-users
  var attributes = ['email', 'firstName', 'lastName'];

  // ... and all other attributes belong under `custom` object
  var customAttributes = ['defaultCurrency', 'isAdmin', 'isProviderAdmin',
  // FIXME: parentCompany attributes
  // These are sent to LaunchDarkly as `custom` attributes.
  // They are the values of user company and working in impersonation mode.
  'parentCompanyId', 'parentCompanyIsCustomer', 'parentCompanyName', 'parentCompanyType', 'timezone', 'title', 'titleType'];

  // LaunchDarkly requires an unique `key` attribute per user
  var user = { key: _User2.default.currentUserId() };

  attributes.forEach(function (attr) {
    if ((0, _isFunction2.default)(_User2.default[attr])) user[attr] = _User2.default[attr]();
  });

  if (customAttributes.length) {
    user.custom = {};

    customAttributes.forEach(function (attr) {
      if ((0, _isFunction2.default)(_User2.default[attr])) user.custom[attr] = _User2.default[attr]();
    });
  }

  return user;
}

function getLDUser() {
  if (!user) user = createUser();

  return user;
}

/** Class representing feature flags for Unified user */

var UserFlags = function () {
  function UserFlags() {
    (0, _classCallCheck3.default)(this, UserFlags);
  }

  (0, _createClass3.default)(UserFlags, null, [{
    key: 'setLdClientSideId',

    /**
     * Get authentication token for user
     *
     * @static
     *
     * @param {string} flag Feature flag name
     * @param {boolean} enabledDefault Should missing flag be considered enabled? (default: false)
     *
     * @return {Object} Promise
     */

    value: function setLdClientSideId(id) {
      ldClientSideId = id;
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled(flag) {
      var enabledDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var ldUser = getLDUser();

      // Initialize the client if:
      //   - client is not created yet
      //   - Or if the last client failed, create a new one to replace it.
      if (!client || clientStatus.failed) {
        if (ldClientSideId && (0, _isString2.default)(ldClientSideId)) {
          client = (0, _launchdarklyJsClientSdk.initialize)(ldClientSideId, ldUser, options);
        } else {
          // reset ldClientSideId to default
          ldClientSideId = process.env.LD_CLIENT_SIDE_ID || _User2.default.ldClientSideId() || (window ? window.LD_CLIENT_SIDE_ID : undefined);
          if ((0, _isString2.default)(ldClientSideId)) {
            client = (0, _launchdarklyJsClientSdk.initialize)(ldClientSideId, ldUser, options);
          }
        }

        clientStatus = {
          failed: false,
          initialized: false
        };
      }

      return new _promise2.default(function (resolve, reject) {
        if (global && global.__USER_FLAG_FIXTURES__) {
          // If feature flag fixtures found, use those ...
          resolve((0, _stringUtils.convertToBoolean)(fixtures[flag] || enabledDefault));
        } else if (client) {
          if (!clientStatus.initialized) {
            // If the client is not initialized, register listeners to two events.
            client.on('initialized', function () {
              clientStatus.initialized = true;
              clientStatus.failed = false;
              resolve(client.variation(flag, enabledDefault));
            });

            client.on('failed', function () {
              clientStatus.initialized = false;
              clientStatus.failed = true;
              reject(new Error(LD_CLIENT_FAILED));
            });
          } else {
            // when initialized, subsequent calls must simply resolve
            resolve(client.variation(flag, enabledDefault));
          }
        } else {
          // ... or fail with an error
          reject(new Error(USER_FLAGS_INIT_FAIL));
        }
      });
    }
  }]);
  return UserFlags;
}();

exports.default = UserFlags;
//# sourceMappingURL=UserFlags.js.map